(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  // Casa logo: click animation
  document.addEventListener('DOMContentLoaded', function() {
    var logoLink = document.querySelector('.header__heading-link');
    var logoSvg = logoLink && logoLink.querySelector('.casa-logo-svg');
    if (!logoSvg) return;

    logoLink.addEventListener('click', function(e) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var isHome = window.location.pathname === '/' || window.location.pathname === '';
      e.preventDefault();
      logoSvg.classList.add('is-clicking');
      setTimeout(function() {
        logoSvg.classList.remove('is-clicking');
        if (!isHome) window.location.href = logoLink.href;
      }, 400);
    });
  });

  // Transparent header on home
  (function() {
    if (!document.body.classList.contains('page-home')) return;
    var stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader) return;
    var wrapper = stickyHeader.querySelector('.header-wrapper') || stickyHeader;
    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    var drawerOpen = false;

    // Los items dentro de un panel de submenu (dropdown) NUNCA se pintan inline:
    // el panel es claro, asi que el CSS los mantiene oscuros. (Fix por Claude)
    function paintMenuItems(color) {
      stickyHeader.querySelectorAll('.header__menu-item, .header__menu-item span, .list-menu__item--link').forEach(function(el) {
        if (el.closest('.header__submenu')) {
          el.style.removeProperty('color');
          return;
        }
        el.style.setProperty('color', color, 'important');
      });
    }

    function setTransparent() {
      stickyHeader.classList.remove('is-scrolled');
      wrapper.style.setProperty('background', 'transparent', 'important');
      wrapper.style.setProperty('background-color', 'transparent', 'important');
      wrapper.style.setProperty('backdrop-filter', 'none', 'important');
      wrapper.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
      wrapper.style.setProperty('border-bottom', 'none', 'important');
      wrapper.style.setProperty('box-shadow', 'none', 'important');
      stickyHeader.querySelectorAll('.casa-logo-svg path').forEach(function(p) { p.style.setProperty('fill', '#F7F7F5', 'important'); });
      paintMenuItems('#F7F7F5');
      stickyHeader.querySelectorAll('.header__icon').forEach(function(el) { el.style.setProperty('color', '#F7F7F5', 'important'); });
    }

    function setBlur() {
      stickyHeader.classList.add('is-scrolled');
      wrapper.style.setProperty('background', 'rgba(247,247,245,0.22)', 'important');
      wrapper.style.setProperty('background-color', 'rgba(247,247,245,0.22)', 'important');
      wrapper.style.setProperty('backdrop-filter', 'blur(14px) saturate(1.1)', 'important');
      wrapper.style.setProperty('-webkit-backdrop-filter', 'blur(14px) saturate(1.1)', 'important');
      wrapper.style.setProperty('border-bottom', '1px solid rgba(42,26,31,0.06)', 'important');
      stickyHeader.querySelectorAll('.casa-logo-svg path').forEach(function(p) { p.style.setProperty('fill', '#4F2533', 'important'); });
      paintMenuItems('#4F2533');
      stickyHeader.querySelectorAll('.header__icon').forEach(function(el) { el.style.setProperty('color', '#4F2533', 'important'); });
    }

    function setDrawerOpenState() {
      stickyHeader.classList.add('is-scrolled');
      wrapper.style.setProperty('background', '#F7F7F5', 'important');
      wrapper.style.setProperty('background-color', '#F7F7F5', 'important');
      wrapper.style.setProperty('backdrop-filter', 'none', 'important');
      wrapper.style.setProperty('-webkit-backdrop-filter', 'none', 'important');
      wrapper.style.setProperty('border-bottom', '1px solid rgba(42,26,31,0.06)', 'important');
      wrapper.style.setProperty('box-shadow', 'none', 'important');
      stickyHeader.querySelectorAll('.casa-logo-svg path').forEach(function(p) { p.style.setProperty('fill', '#4F2533', 'important'); });
      paintMenuItems('#4F2533');
      stickyHeader.querySelectorAll('.header__icon').forEach(function(el) { el.style.setProperty('color', '#4F2533', 'important'); });
    }

    function updateHeader() {
      if (drawerOpen) {
        setDrawerOpenState();
        return;
      }
      if (window.scrollY > 50) {
        setBlur();
      } else {
        setTransparent();
      }
    }

    var drawerSummary = drawerDetails ? drawerDetails.querySelector('summary') : null;

    if (drawerSummary) {
      drawerSummary.addEventListener('click', function() {
        // Dawn retrasa ~400ms la eliminación del atributo "open" al cerrar
        // (para animar la salida), así que no esperamos al evento "toggle":
        // leemos la intención en el clic mismo, antes de que Dawn la procese.
        drawerOpen = !drawerDetails.hasAttribute('open');
        updateHeader();
      });
    }

    if (drawerDetails) {
      drawerDetails.addEventListener('toggle', function() {
        drawerOpen = drawerDetails.open;
        updateHeader();
      });
    }

    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  })();

  } catch(e) { console.error(e); }
})();
})();
